export enum RequestReplicateType {
    scheduled = 'scheduled',
    user = 'user',
}
